
import imgPricing1 from 'assets/images/app/pricing/01.png';
import imgPricing2 from 'assets/images/app/pricing/02.png';
import imgPricing3 from 'assets/images/app/pricing/03.png';

const data = {
    change_pricing: [
      {
        thumb: imgPricing1,
        name: 'Basic Plan',
        price: 'Free',
        description: 'For up to 10 users',
        link: '#',
        btnText: 'Get Package',
        services:[
            {
                content: 'Push Notification.',
                className: 'on'
            },
            {
                content: 'Offline Synchronization.',
                className: 'on'
            },
            {
                content: 'SQL Database.',
                className: 'on'
            },
            {
                content: 'Unlimited Projects.',
                className: 'off'
            },
            {
                content: '24/7 Supports.',
                className: 'off'
            }
        ]
      },{
        thumb: imgPricing2,
        name: 'Standard Plan',
        price: '$75.00',
        description: 'Lorem ipsum dolor sit amet consectetur elit, sed.',
        link: '#',
        btnText: 'Get Package',
        services:[
            {
                content: 'Push Notification.',
                className: '--on'
            },
            {
                content: 'Offline Synchronization.',
                className: '--on'
            },
            {
                content: 'SQL Database.',
                className: '--on'
            },
            {
                content: 'Speech & Text Analytics.',
                className: '--on'
            },
            {
                content: '24/7 Supports.',
                className: '--off'
            }
        ]
      },
      {
        thumb: imgPricing3,
        name: 'Premium Plan',
        price: '$99.99',
        description: 'Lorem ipsum dolor sit amet consectetur elit, sed.',
        link: '#',
        btnText: 'Get Package',
        services:[
            {
                content: 'Push Notification.',
                className: '--on'
            },
            {
                content: 'Offline Synchronization.',
                className: '--on'
            },
            {
                content: 'SQL Database.',
                className: '--on'
            },
            {
                content: 'Speech & Text Analytics.',
                className: '--on'
            },
            {
                content: '24/7 Supports.',
                className: '--on'
            }
        ]
      }
      
    ],
    requirements_pricings: [
        {
          thumb: imgPricing1,
          name: 'Basic Plan',
          price: 'Free',
          description: 'Forever',
          link: '#',
          btnText: 'Get Package',
          services:[
              {
                  content: 'Requirements Management',
                  className: 'on'
              },
              {
                  content: 'Real-Time Dashboard.',
                  className: 'on'
              },
              {
                content: 'Unlimited Participants.',
                className: 'off'
                },
                {
                    content: 'Unlimited Projects.',
                    className: 'off'
                },
                {
                    content: 'Unlimited Users.',
                    className: 'off'
                }
          ]
        },{
          thumb: imgPricing2,
          name: 'Consultant Plan',
          price: '100 USD',
          description: 'Per Month',
          link: '#',
          btnText: 'Get Package',
          services:[
            {
                content: 'Requirements Management.',
                className: 'on'
            },
            {
                content: 'Real-Time Dashboard.',
                className: 'on'
            },
              {
                  content: 'Unlimited Participants.',
                  className: 'on'
              },
              {
                  content: 'Unlimited Projects.',
                  className: 'on'
              },
              {
                  content: 'Unlimited Users.',
                  className: 'off'
              }
          ]
        },
        {
          thumb: imgPricing3,
          name: 'Premium Plan',
          price: '10 USD',
          description: 'Per User Per Month.',
          link: '#',
          btnText: 'Get Package',
          services:[
            {
                content: 'Requirements Management.',
                className: 'on'
            },
            {
                content: 'Real-Time Dashboard.',
                className: 'on'
            },
              {
                  content: 'Unlimited Participants.',
                  className: 'on'
              },
              {
                  content: 'Unlimited Projects.',
                  className: 'on'
              },
              {
                  content: 'Unlimited Users.',
                  className: 'on'
              }
          ]
        }
        
      ]
    
  };
  export default data;
  